"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var contests_core_1 = require("@biw/contests-core");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var contests_constants_1 = require("@biw/contests-constants");
function getManagerGoalSelectionProps(state, program) {
    var programViewId = program.programViewId;
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId);
    var progressCount = get_1.default(progressModel, 'progressCount') || {
        total: 0,
        count: 0,
        percent: 0,
    };
    return tslib_1.__assign({ tileType: 'manager-progress', statusCode: contests_constants_1.KEY_CODES.participantsOnTrack }, progressCount, { footerMessageCode: program.isCheckingResults ?
            contests_constants_1.KEY_CODES.checkingResults :
            contests_constants_1.KEY_CODES.timeToMotivate, buttonTextCode: contests_constants_1.KEY_CODES.viewDetails, daysLeft: program.daysToProgramEndDate, calendarLabel: program.programHasEnded ?
            'dashboard.tile.common.waitingForFinal' :
            'progress.daysToEarnLabel' });
}
exports.default = getManagerGoalSelectionProps;
//# sourceMappingURL=progress-props.js.map